export const DealStatus = {
    enquiry: {
        value: 1,
        label: 'Enquiry'
    },
    holdRequest: {
        value: 2,
        label: 'Hold Request'
    },
    onHold: {
        value: 3,
        label: 'On Hold'
    },
    sold: {
        value: 4,
        label: 'Sold'
    },
    completed: {
        value: 5,
        label: 'Completed'
    },
    cancelled: {
        value: 6,
        label: 'Cancelled'
    },
    archived: {
        value: 7,
        label: 'Archived'
    }
};
